/**
 * Normaliza valores de filtro booleano (true/false, prefijo =, yes/no).
 * @param {*} raw
 * @returns {boolean|null|undefined|*}
 */
export function coerceBooleanFilterValue(raw) {
  if (raw === true || raw === false) return raw;
  if (raw === null || raw === undefined) return raw;
  let str = String(raw).trim();
  if (str.startsWith("=")) str = str.slice(1).trim();
  const lower = str.toLowerCase();
  if (lower === "true" || lower === "yes" || lower === "1") return true;
  if (lower === "false" || lower === "no" || lower === "0") return false;
  return raw;
}

export function isBooleanFilterField(field) {
  return field && field.type === "boolean";
}
